export enum NoteListVariant {
    DEFAULT = 'default',
    CUSTOMER_PROFILE = 'customer-profile',
}
